import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    loadingStatus: false,
    requestTypeItems: [],
  },
  getters: {
    loadingStatus (state) {
      return state.loadingStatus
    },
    requestTypeItems (state) {
      return state.requestTypeItems
    }
  },
  mutations: {
    SET_LOADING_STATUS (state, payload) {
      state.loadingStatus = payload
    },
    SET_REQUEST_TYPE_ITEMS (state, payload) {
      state.requestTypeItems = payload
    }
  },
  actions: {
    fetchRequestTypes (context) {
      console.log('actions loadRequestTypeItems')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/requestTypes`).then((response) => {
        context.commit('SET_REQUEST_TYPE_ITEMS', response.data)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbarOnLoadFail', error)
      })
    },
    loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/requestTypes`, payload)
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/requestTypes`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/requestTypes/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('-> delete', payload)
      return Vue.axios.delete(`${config.serverURI}/requestTypes/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/requestType.js